module.exports = __webpack_public_path__ + "c019bd0c2394cf1f74d57311eb967f55.png";